import { useMutation } from '@tanstack/react-query';
import request from '#api/axios';

import { BoxIcon, Text } from '#atoms';
import Verified from '#assets/svg/verified.svg';

import { dottedDateFormatter } from '#utils/dateFormatter';
import {
  LabelBox,
  CoachInfoBox,
  InfoDetailBox,
  DetailList
} from '#templates/CoachDetailContent/DetailInfo/CoachIntroduce/styles';
import { IBase } from '#types/api';
import { Link } from 'react-router-dom';
import { useToast } from '#providers/ToastProvider';
import EmptyContent from 'src/refactor_shared/ui/empty-content';

interface CriteriaItemsInterface extends IBase {
  [key: string]: string;
  startAt: string;
  endAt: string;
  at: string;
  gotAt: string;
  name: string;
}

const Criterias = ({
  criteriaItems,
  criteriaTitle,
  startTimeParam = 'startAt',
  endTimeParam = 'endAt',
  certificateParam,
  subCriteriaTitle,
  to,
  isReadonly = false
}: {
  criteriaItems: CriteriaItemsInterface[];
  criteriaTitle: string;
  startTimeParam?: string;
  endTimeParam?: string;
  certificateParam?: string;
  subCriteriaTitle?: string;
  to: string;
  isReadonly?: boolean;
}) => {
  const { showToast } = useToast();

  const { mutate } = useMutation({
    mutationFn: async (payload: string) =>
      await request({
        method: 'delete',
        url: `${to}/${payload}`
      }),
    onSuccess: () => {
      showToast({
        message: '해당 자격사항을 삭제 하였습니다.'
      });
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: `일시적인 오류입니다. 다시 시도해주세요.`
      });
    }
  });

  const onDeleteQualification = (id: string) => {
    mutate(id);
  };

  return (
    <>
      <CoachInfoBox>
        <LabelBox>
          <Text textStyle="t3">{criteriaTitle}</Text>
          {!isReadonly && (
            <Link to={`/profile/qualification/${to}`}>
              <BoxIcon type="plus-purple" onlyIcon size={20} />
            </Link>
          )}
        </LabelBox>
        {criteriaItems &&
        criteriaItems.length > 0 &&
        criteriaItems.filter(item => item.status === 'NORMAL').length > 0 ? (
          <DetailList>
            {criteriaItems
              .filter(item => item.status === 'NORMAL')
              .map(item => (
                <InfoDetailBox key={item.id}>
                  <div className="flex justify-between items-center gap-16">
                    {!isReadonly && (
                      <button
                        type="button"
                        onClick={() => onDeleteQualification(item.id)}
                      >
                        <BoxIcon type="wastebasket" onlyIcon size={18} />
                      </button>
                    )}
                    <div>
                      <p className="flex items-center gap-4">
                        <span>{item.name}</span>
                        <span>
                          {subCriteriaTitle ? item[subCriteriaTitle] : null}
                        </span>
                        {item.isVerified ? <img src={Verified} /> : null}
                      </p>
                      <div className="text-[12px] text-[#8E899F]">
                        {certificateParam ? (
                          <p>
                            {item[certificateParam]
                              ? dottedDateFormatter(item[certificateParam])
                              : ''}
                          </p>
                        ) : (
                          <p className="flex itemcenter gap-4">
                            <span>
                              {item[startTimeParam]
                                ? dottedDateFormatter(item[startTimeParam])
                                : ''}
                            </span>
                            {item[startTimeParam] ? <span>~</span> : null}
                            <span>
                              {item[endTimeParam]
                                ? dottedDateFormatter(item[endTimeParam])
                                : ''}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  {!isReadonly && (
                    <Link to={`/profile/qualification/${to}`} state={item.id}>
                      <BoxIcon type="next-arrow" onlyIcon size={16} />
                    </Link>
                  )}
                </InfoDetailBox>
              ))}
          </DetailList>
        ) : (
          <EmptyContent>등록된 {criteriaTitle}이 없습니다</EmptyContent>
        )}
      </CoachInfoBox>
    </>
  );
};

export default Criterias;
